import { render, staticRenderFns } from "./EditInstallationChangelog.vue?vue&type=template&id=d27960b6&scoped=true&"
import script from "./EditInstallationChangelog.vue?vue&type=script&lang=js&"
export * from "./EditInstallationChangelog.vue?vue&type=script&lang=js&"
import style0 from "./EditInstallationChangelog.vue?vue&type=style&index=0&id=d27960b6&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d27960b6",
  null
  
)

export default component.exports